var getChatRoom = function (state, chatroomId) { return state.chatrooms.byId[chatroomId] || {}; };
var getListState = function (state, type) { return state.chatroomsLists[type]; };
var getMessages = function (state) { return state.messages || {}; };
export { getChatRoom, getMessages, getListState };
